import { isNumber, isString } from 'utils/tsHelpers';
import { HandlebarNumber } from './HandlebarNumber';

export class HandlebarFloat extends HandlebarNumber {
  toString() {
    // Ensure float renders with decimal point and at least 1 decimal place
    const alreadyHasDecimal = !!(this.value % 1);
    return alreadyHasDecimal ? this.value.toString() : this.value.toFixed(1);
  }

  static parse(from: unknown): HandlebarFloat {
    if (isNumber(from)) {
      return new HandlebarFloat(from);
    } else if (isString(from)) {
      return new HandlebarFloat(parseFloat(from));
    }
    return new HandlebarFloat(NaN);
  }
}
